module.exports = "/img/logo.6109c517.png";